<template>
  <div id="posts">
    <section class="is-fullheight">
      <Navigation></Navigation>
      <div class="has-margin-top-40">
        <div class="container content">
          <nav class="level is-mobile">
            <div class="level-left">
              <div class="level-item">
                <a @click="postFilterKey = 'orderedScore'" type="is-primary">
                  <i class="ri-flashlight-fill"></i>&nbsp;<span class="has-text-brand">{{ $t('posts.trending') }}</span>
                </a>
              </div>
              <div class="level-item">
                <a @click="postFilterKey = 'orderedMostRecent'" type="is-primary">
                  <i class="ri-time-line"></i>&nbsp;<span class="has-text-brand">{{ $t('posts.most-recent') }}</span>
                </a>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <router-link v-if="userProfile.name" to="/post" class="link">
                  <i class="ri-add-circle-line"></i>&nbsp;<span class="has-text-brand">{{ $t('posts.add-post') }}</span>
                </router-link>
                <a v-else @click="openLoginModal()" class="link">
                  <i class="ri-add-circle-line has-text-success"></i>&nbsp;<span class="has-text-brand">{{ $t('posts.add-post') }}</span>
                </a>
              </div>
            </div>
          </nav>
          <!--
          <div>
            <b-field>
              <b-input
                v-model="searchPosts"
                type="text"
                placeholder="Search"
                id="title"
              ></b-input>
            </b-field>
          </div>
          <div class="has-margin-bottom-40">
            <div class="buttons">
              <b-button @click="postFilterKey = 'orderedScore'" type="is-primary" class="is-outlined"><b-icon pack="fas" icon="fire"></b-icon></b-button>
              <b-button @click="postFilterKey = 'orderedMostRecent'" type="is-success" class="is-outlined"><b-icon pack="fas" icon="clock"></b-icon></b-button>
              <b-button @click="postFilterKey = 'orderedLestRecent'" type="is-danger" class="is-outlined">Oldest</b-button>
              <b-button @click="postFilterKey = 'orderedTopLikes'" type="is-warning" class="is-outlined"><b-icon pack="fas" icon="thumbs-up"></b-icon></b-button>
            </div>
          </div>-->

          <!--
          <transition name="fade">
            
            <div
              v-if="hiddenPosts.length"
              @click="showNewPosts"
              class="hidden-posts has-margin-bottom-40"
            >
              <span class="new-posts">{{ hiddenPosts.length }}</span>
              new
              <span v-if="hiddenPosts.length > 1">posts</span>
              <span v-else>post</span>
              - Click to load
            </div>
          </transition>
          -->
          
          <div v-if="posts.length" class="columns is-multiline">
            <div
              v-for="post in filterPosts"
              v-bind:key="post.value"
              class="column is-half-tablet is-one-quarter-desktop is-one-sixth-widescreen is-flex"
            >
              <div class="has-padding has-content-background has-box-shadow has-width-100-percent">
                <div class="has-margin-bottom-20">
                  <!--
                  <div class="is-multiline-image"> 
                    <img src="https://via.placeholder.com/800" :alt="post.industry" class="is-multiline-image has-box-shadow has-rounded-3" />
                  </div>-->
                  <div v-if="post.imageUrl1" class="is-multiline-image">
                    <img :src="post.imageUrl1" :alt="post.industry" class="is-multiline-image has-box-shadow has-rounded-3" />
                  </div>
                   
                  <div v-else class="has-text-centered is-full-width">
                    <div class="is-placeholder-image has-background-brand has-text-grey has-box-shadow has-rounded-3 has-padding">
                      <i class="ri-car-line ri-xl has-text-success"></i>
                      <br />
                      {{ $t('posts.no-image') }}
                    </div>
                  </div>
                </div>
                <div>
                  <div v-if="post.industry">
                    <a @click="detailPost(post)" class="is-success is-size-5 has-no-padding has-no-margin">
                      <span v-if="post.industry === 'audi-e-tron'">{{ $t('post.input-option-audi-e-tron') }}</span>
                      <span v-else-if="post.industry === 'citroen-berlingo'">{{ $t('post.input-option-citroen-berlingo') }}</span>
                      <span v-else-if="post.industry === 'ds-ds3-crossback-e-tens'">{{ $t('post.input-option-ds-ds3-crossback-e-tense') }}</span>
                      <span v-else-if="post.industry === 'hyundai-ioniq-electric'">{{ $t('post.input-option-hyundai-ioniq-electric') }}</span>
                      <span v-else-if="post.industry === 'hyundai-kona-electric-39-kwh'">{{ $t('post.input-option-hyundai-kona-electric-39-kwh') }}</span>
                      <span v-else-if="post.industry === 'hyundai-kona-electric-64-kwh'">{{ $t('post.input-option-hyundai-kona-electric-64-kwh') }}</span>
                      <span v-else-if="post.industry === 'jaguar-i-pace'">{{ $t('post.input-option-jaguar-i-pace') }}</span>
                      <span v-else-if="post.industry === 'kia-e-niro'">{{ $t('post.input-option-kia-e-niro') }}</span>
                      <span v-else-if="post.industry === 'mg-zs-ev'">{{ $t('post.input-option-mg-zs-ev') }}</span>
                      <span v-else-if="post.industry === 'nissan-e-nv200-combi-visia'">{{ $t('post.input-option-nissan-e-nv200-combi-visia') }}</span>
                      <span v-else-if="post.industry === 'nissan-e-nv200-visia'">{{ $t('post.input-option-nissan-e-nv200-visia') }}</span>
                      <span v-else-if="post.industry === 'nissan-leaf'">{{ $t('post.input-option-nissan-leaf') }}</span>
                      <span v-else-if="post.industry === 'peugeot-e-208'">{{ $t('post.input-option-peugeot-e-208') }}</span>
                      <span v-else-if="post.industry === 'peugeot-partner'">{{ $t('post.input-option-peugeot-partner') }}</span>
                      <span v-else-if="post.industry === 'renault-kangoo-crew-van-ze-33'">{{ $t('post.input-option-renault-kangoo-crew-van-ze-33') }}</span>
                      <span v-else-if="post.industry === 'renault-kangoo-panel-van-ze-33'">{{ $t('post.input-option-renault-kangoo-panel-van-ze-33') }}</span>
                      <span v-else-if="post.industry === 'renault-master-van-ze'">{{ $t('post.input-option-renault-master-van-ze') }}</span>
                      <span v-else-if="post.industry === 'renault-twizy'">{{ $t('post.input-option-renault-twizy') }}</span>
                      <span v-else-if="post.industry === 'renault-zoe'">{{ $t('post.input-option-renault-zoe') }}</span>
                      <span v-else-if="post.industry === 'smart-eq-forfou'">{{ $t('post.input-option-smart-eq-forfou') }}</span>
                      <span v-else-if="post.industry === 'smart-eq-fortwo-cabrio'">{{ $t('post.input-option-smart-eq-fortwo-cabrio') }}</span>
                      <span v-else-if="post.industry === 'smart-eq-fortwo-coupé'">{{ $t('post.input-option-smart-eq-fortwo-coupé') }}</span>
                      <span v-else-if="post.industry === 'tesla-model-3'">{{ $t('post.input-option-tesla-model-3') }}</span>
                      <span v-else-if="post.industry === 'tesla-model-s'">{{ $t('post.input-option-tesla-model-s') }}</span>
                      <span v-else-if="post.industry === 'tesla-model-x'">{{ $t('post.input-option-tesla-model-x') }}</span>
                      <span v-else-if="post.industry === 'volkswagen-e-golf'">{{ $t('post.input-option-volkswagen-e-golf') }}</span>
                      <span v-else-if="post.industry === 'volkswagen-e-up'">{{ $t('post.input-option-volkswagen-e-up') }}</span>            
                    </a>
                  </div>
                  <div v-if="post.price">
                    <span v-if="post.currency === 'USD'" class="has-text-info">$</span>
                    <span v-else-if="post.currency === 'GBP'" class="has-text-info">£</span>
                    <span v-else-if="post.currency === 'EUR'" class="has-text-info">€</span>
                    <span v-else-if="post.currency === 'AUD'" class="has-text-info">$</span>
                    <span v-else-if="post.currency === 'CAD'" class="has-text-info">$</span>
                    <span v-else-if="post.currency === 'JPY'" class="has-text-info">JP¥</span>
                    <span v-else-if="post.currency === 'BRL'" class="has-text-info">R$</span>
                    <span v-else-if="post.currency === 'INR'" class="has-text-info">₹</span>
                    <span v-else-if="post.currency === 'CNY'" class="has-text-info">¥</span>
                    <span v-else class="has-text-info">$</span>
                    <span class="has-text-info is-size-5">{{ post.price | formatCurrency }}</span>
                    <span class="has-text-grey">({{ post.currency }})</span>
                    <span v-if="post.pricetype === 'unit'" class="is-size-7">
                    </span>
                    <span v-else-if="post.pricetype === 'monthly'" class="is-size-7 has-text-grey-light">
                      {{ $t('postdetails.per-month') }}
                    </span>
                    <span v-else-if="post.pricetype === 'annual'" class="is-size-7 has-text-grey-light">
                      {{ $t('postdetails.per-year') }}
                    </span>
                    <span v-else>
                    </span>
                    <hr />
                  </div>

                  
                  <!--
                  <span class="is-size-5">
                    <a @click="detailPost(post)">{{ post.title }}</a>&nbsp;
                  </span>
                  <p class="has-text-danger">
                    Score: {{ post.score }}
                  </p>-->
                  <div>
                    {{ post.content | trimLength }}

                    <span v-if="currentUser && post.userId == currentUser.uid">
                      <span class="has-text-grey-dark">&nbsp;|&nbsp;</span>
                      <a @click="editPostPage(post)" class="has-text-warning">{{ $t('posts.edit') }}</a>
                      <span class="has-text-grey-dark">&nbsp;.&nbsp;</span>
                      <a @click="deletePostModal(post)" class="has-text-danger">{{ $t('posts.delete') }}</a>
                    </span>
                  </div>
                  <span class="has-text-grey-light is-size-7">
                    <i>{{ post.createdOn | formatDate }}</i>
                  </span>
                  <div class="is-size-7 has-text-grey-light">{{ $t('posts.posted-by') }}: {{ post.userName }}</div>
                  <nav class="level is-mobile">
                    <div class="level-left">
                      <a
                        v-if="userProfile.name"
                        @click="likePost(post.id, post.likes)"
                        class="level-item"
                      >
                        <!--<i class="ri-arrow-up-s-line has-text-warning"></i>-->
                        <i class="ri-arrow-up-s-line has-text-warning"></i>
                        <span class="has-text-primary">&nbsp;{{ post.likes }}</span>
                      </a>
                      <a v-else @click="openLoginModal()" class="level-item">
                        <i class="ri-arrow-up-s-line has-text-warning"></i>
                        <span class="has-text-primary">&nbsp;{{ post.likes }}</span>
                      </a>
                      <a
                        v-if="userProfile.name"
                        @click="openCommentModal(post)"
                        class="level-item"
                      >
                        <i class="ri-chat-1-fill"></i> 
                        &nbsp;{{ post.comments }}
                      </a>
                      <a v-else @click="openLoginModal()" class="level-item">
                        <i class="ri-chat-1-fill"></i> 
                        &nbsp;{{ post.comments }}
                      </a>
                      
                      <!--
                      <a href="#" target="_blank" rel="nofollow">{{ post.website }}</a>
                      -->
                    </div>
                  </nav>
                  <div v-if="userProfile.role == 'admin'">
                    <hr />
                    <div class="control has-margin-bottom-10">
                      <b-taglist attached>
                        <b-tag type="is-dark">{{ $t('posts.status') }}:</b-tag>
                        <b-tag v-if="post.status == 'approved'" type="is-success">{{ $t('posts.approved') }}</b-tag>
                        <b-tag v-else type="is-info">{{ $t('posts.pending') }}</b-tag>
                      </b-taglist>
                    </div>

                    <div class="buttons">
                      <a
                        v-if="post.status == 'pending'"
                        @click="approvePost(post.id)" 
                        class="button is-success is-small"
                      >
                        <span class="icon is-small">
                          <i class="ri-check-line"></i> 
                        </span>
                        <span>&nbsp;{{ $t('posts.approve') }}</span>
                      </a>
                      <a
                        @click="deletePostModal(post)"
                        class="button is-danger is-small"
                      >{{ $t('posts.delete') }}</a> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="box has-text-centered">
            <i class="ri-error-warning-line ri-2x has-text-info"></i> 
            <br />
            <p>{{ $t('posts.no-results') }}</p>
          </div>
        </div>
      </div>
      <!--<transition name="fade">-->
      <a @click="scrollToTop()" id="btn-scroll-to-top">
        <div class="menu-fixed has-box-shadow">
          <div class="has-padding has-content-background">
            <i class="ri-arrow-up-line ri-lg has-text-info"></i>
          </div>
        </div>
      </a>
      <!--</transition>-->
      <!--
      <b-loading :active.sync="isLoading" :can-cancel="true">
        <div id="spinner"></div>
      </b-loading>
      -->
    </section>

    <b-modal :active.sync="showDeleteModal" :width="640" scroll="keep">
      <article class="message is-info">
        <div class="message-header">
          <p>{{ $t('posts.delete-confirmation') }}</p>
        </div>
        <div class="message-body has-content-background">
          {{ $t('posts.delete-confirmation-message') }}
        </div>
      </article>
      <div class="box has-content-background">
        <p>
          <span class="is-size-5">{{ fullPost.title }}&nbsp;</span>
          <span class="has-text-grey-light is-size-7">
            <i>{{ fullPost.createdOn | formatDate }}</i>
          </span>
        </p>
        <div class="is-size-7 has-text-grey-light">{{ $t('posts.posted-by') }}: {{ fullPost.userName }}</div>
      </div>
      <div class="box has-content-background">
        <div class="columns">
          <div class="column">
            <b-button @click="deletePost(fullPost)" type="is-danger is-fullwidth">{{ $t('posts.button-delete-post') }}</b-button>
          </div>
          <div class="column">
            <b-button
              @click="showDeleteModal = false"
              type="is-dark is-fullwidth"
            >{{ $t('posts.button-cancel-post') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- comment modal 
    <transition name="fade">
      <div v-if="showCommentModal" class="c-modal">
        <div class="c-container">
          <a @click="closeCommentModal">X</a>
          <p>add a comment</p>
          <form @submit.prevent>
            <textarea v-model.trim="comment.content"></textarea>
            <button @click="addComment" :disabled="comment.content == ''" class="button">add comment</button>
          </form>
        </div>
      </div>
    </transition>-->

    <b-modal :active.sync="showCommentModal" :width="640" scroll="keep">
      <div class="item has-content-background">
        <div class="columns">
          <div class="column">
            <div class="item-content">
              <p>
                <span class="is-size-5">{{ fullPost.title }}&nbsp;</span>
                <span class="has-text-grey-light is-size-7">
                  <i>{{ fullPost.createdOn | formatDate }}</i>
                </span>
              </p>
              <div class="is-size-7 has-text-grey-light">{{ $t('posts.posted-by') }}: {{ fullPost.userName }}</div>
              <!--
              <div>
                <p>{{ fullPost.content | trimLength }}</p>
              </div>-->
            </div>
          </div>
        </div>
      </div>

      <div class="box has-content-background">
        <form @submit.prevent>
          <b-field :label="$t('posts.comment')">
            <b-input
              v-model.trim="comment.content"
              :placeholder="$t('posts.input-ph-comment')"
              maxlength="20"
              type="text"
              id="comment"
            ></b-input>
          </b-field>
          <b-button
            @click="addComment"
            :disabled="comment.content == ''"
            class="is-primary"
          >{{ $t('posts.button-comment') }}</b-button>
        </form>
        <hr />
        <div v-show="postComments.length" class="comments">
          <div v-for="comment in postComments" v-bind:key="comment" class="has-text-grey-light">
            {{ comment.userName }}
            <span
              class="is-size-7 has-text-grey-light"
            >{{ comment.createdOn | formatDate }}</span>

            <span v-if="currentUser && comment.userId == currentUser.uid">
              <span class="has-text-grey-dark">&nbsp;|&nbsp;</span>
              <a @click="deleteComment(comment)" class="has-text-danger">{{ $t('posts.delete') }}</a>
            </span>

            <p>{{ comment.content }}</p>

            <hr />
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="showLoginModal" :width="640" scroll="keep">
      <article class="message is-info">
        <div class="message-header">
          <p>{{ $t('posts.message-sign-in') }}</p>
        </div>
        <div class="message-body has-content-background">
          <div class="has-padding-bottom-20">
            {{ $t('posts.message-sign-up') }}
            <br />
          </div>
          <div class="has-margin-bottom-10">
            <a @click="logout" class="button is-primary-grad is-rounded">{{ $t('posts.button-sign-up') }}</a>
          </div>
          <div>
            <small class="has-text-success">
              <em>{{ $t('posts.its-free') }}</em>
            </small>
          </div>
        </div>
      </article>
    </b-modal>

    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true">
      <div id="spinner"></div>
    </b-loading>
    <b-loading :is-full-page="isFullPage" :active.sync="isFakeLoading" :can-cancel="true">
      <div id="spinner"></div>
    </b-loading>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

import Navigation from "@/components/Navigation";

export default {
  data() {
    return {
      post: {
        title: "",
        content: "",
        website: "",
        imageUrl: "",
        score: "",
        status: "",
        currency: "",
        price: "",
        pricetype: ""
      },
      /*
      localPost: {
        title: "",
        content: "",
        website: "",
        imageUrl: "",
        price: "",
        status: "",
      },*/
      comment: {
        postId: "",
        userId: "",
        content: "",
        postComments: 0
      },
      showCommentModal: false,
      fullPost: {},
      currentPost: {},
      postComments: [],
      showPostModal: false,
      showDeleteModal: false,
      closeDeletePostModal: {},

      isLoading: false,
      isFakeLoading: false,
      isFullPage: "",
      //searchPosts: "",
      searchString: "",
      postFilterKey: "all",

      //totalLikes: "",
      datePosted: "",
      gravity: "",
      score: "",
      style: "",
      showLoginModal: false
    };
  },
  
  components: {
    Navigation
  },

  computed: {
    ...mapState(["userProfile", "currentUser", "posts" /*, "hiddenPosts"*/]),

    postsWithScore() {
      this.isLoading = false;
      let results = this.$store.getters.postsWithScore;
      return results;
    },

    filterPosts() {
      console.log("filterPosts(): " + this.postFilterKey);
      //this.isLoading = false;
      return this[this.postFilterKey];
    },

    all() {
      //return this.posts;
      this.isLoading = false;
      let results = this.$store.getters.postsWithScore;
      window.scrollTo(0, 0);
      return results;
    },

    orderedScore() {
      let results = this.$store.getters.postsWithScore.sort(
        (b, a) => a.score - b.score
      );
      this.scrollToTop();
      this.isLoading = false;
      this.openLoading();
      return results;
    },
    /*
    orderedTopLikes () {
      return this.posts.sort((b, a) => a.likes - b.likes );
    },*/
    orderedMostRecent() {
      let results = this.posts.sort(
        (b, a) => a.createdOn.toDate() - b.createdOn.toDate()
      );
      this.isLoading = false;
      this.scrollToTop();
      //fake loader as results may not change
      this.openLoading();
      //this.isFakeLoading = false;
      return results;
    }
    /*
    orderedLestRecent () {
      console.log("order Least Recent");
      return this.posts.sort((a, b) => a.createdOn.toDate() - b.createdOn.toDate())
    },*/
    /*
      //For Search Field
      var poststhis.postsarray = this.posts,
          searchString = this.searchPosts;

      console.log("search: " + searchString);

      if(!searchString){
        return posts_array;
      }

      searchString = searchString.trim().toLowerCase();
      console.log("search2: " + searchString);

      posts_array = posts_array.filter(function(post){
        console.log("post: " + post.title);

        if (post.title) {
          var currentItem = post.title.trim().toLowerCase();
          if(currentItem.match(searchString)){
            console.log("return item: " + post.title);
            return post;
          }
        }
      })

      // Return an array with the filtered data.
      return posts_array;
      */

    //}
  },

  beforeMount() {
    this.isLoading = true;
    //this.openLoading();
    window.onscroll = function() {
      scrollFunction();
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        document.getElementById("btn-scroll-to-top").style.display = "block";
      } else {
        document.getElementById("btn-scroll-to-top").style.display = "none";
      }
    }
  },

  mounted() {
    this.isLoading = false;
  },

  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch(err => {
          console.log(err);
        });
    },
    openLoading() {
      console.log("onLoading()");
      this.isFakeLoading = true
      setTimeout(() => {
        this.isFakeLoading = false
      }, 500)
    },

    openCommentModal(post) {
      this.comment.postId = post.id;
      this.comment.userId = post.userId;
      this.comment.postComments = post.comments;
      this.showCommentModal = true;

      fb.commentsCollection
        .where("postId", "==", post.id)
        .orderBy("createdOn", "desc")
        .get()
        .then(docs => {
          let commentsArray = [];

          docs.forEach(doc => {
            let comment = doc.data();
            comment.id = doc.id;
            commentsArray.push(comment);
          });

          this.postComments = commentsArray;
          this.fullPost = post;
        })
        .catch(err => {
          console.log(err);
        });
    },

    closeCommentModal() {
      this.comment.postId = "";
      this.comment.userId = "";
      this.comment.content = "";
      this.showCommentModal = false;
    },
    addComment() {
      let postId = this.comment.postId;
      let postComments = this.comment.postComments;

      console.log("add comment");
      console.log("postId:" + postId);

      fb.commentsCollection
        .add({
          createdOn: new Date(),
          content: this.comment.content,
          postId: postId,
          userId: this.currentUser.uid,
          userName: this.userProfile.name
        })
        .then(doc => {
          fb.postsCollection
            .doc(postId)
            .update({
              comments: postComments + 1
            })
            .then(() => {
              this.closeCommentModal();
            });
        })
        .catch(err => {
          console.log(err);
        });
    },

    deleteComment(comment) {
      this.isLoading = true;
      let docId = `${comment.id}`;

      let postId = this.comment.postId;
      let postComments = this.comment.postComments;

      fb.commentsCollection
        .doc(docId)
        .delete()
        .then(doc => {
          fb.postsCollection
            .doc(postId)
            .update({
              comments: postComments - 1
            })
            .then(() => {
              this.isLoading = false;
              this.closeCommentModal();
              
              this.$toast.open({
                message: this.$t("posts.toast-comment-deleted"),
                queue: false,
                type: "is-success"
              });
            });
        })
        .catch(err => {
          console.log(err);
          this.$toast.open({
            message: this.$t("posts.toast-error"),
            queue: false,
            type: "is-warning"
          });
        });
    },

    likePost(postId, postLikes) {
      let docId = `${this.currentUser.uid}_${postId}`;

      fb.likesCollection
        .doc(docId)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.$toast.open({
              message: this.$t("posts.toast-already-voted"),
              queue: false,
              type: "is-info"
            });
            return;
          }

          fb.likesCollection
            .doc(docId)
            .set({
              postId: postId,
              userId: this.currentUser.uid
            })
            .then(() => {
              // update post likes
              fb.postsCollection.doc(postId).update({
                likes: postLikes + 1
              });
              this.$toast.open({
                message: this.$t("posts.toast-vote-added"),
                queue: false,
                type: "is-success"
              });
            });
        })
        .catch(err => {
          console.log(err);
        });
    },

    deletePostModal(post) {
      this.fullPost = post;
      this.showDeleteModal = true;
    },

    deletePost(post) {
      this.isLoading = true;
      let docId = `${post.id}`;
      fb.postsCollection
        .doc(docId)
        .delete()
        .then(() => {
          this.postDeleteFile(post.imageUrl);
          this.showDeleteModal = false;
          this.isLoading = false;
          this.$toast.open({
            message: this.$t("posts.toast-comment-deleted"),
            queue: false,
            type: "is-success"
          });
        })
        .catch(err => {
          console.log(err);
        });
    },

    postDeleteFile(imageUrl) {
      console.log("postDeleteFile()");

      if (imageUrl != null) {
        console.log("delete file: " + imageUrl);
        fb.storage
          .refFromURL(imageUrl)
          .delete()
          .then(() => {
            //this.createPost(downloadURL);
          })
          .catch(err => {
            console.log(err);
            this.snackbarError();
          });
      }
    },
    detailPost(post) {
      let docId = `${post.id}`;
      console.log("doc Id: " + docId);
      this.$router.push({ name: "PostDetails", params: { id: docId } });
    },

    editPostPage(post) {
      let docId = `${post.id}`;
      console.log("doc Id: " + docId);
      this.$router.push({ name: "PostEdit", params: { id: docId } });
    },

    openLoginModal() {
      this.showLoginModal = true;
    },

    scrollListTop() {
      console.log("scrollListTop");
      window.scrollTo(0, 0);
    },

    approvePost(postId) {
      this.isLoading = true;
      let docId = `${postId}`;
      let status = "approved";
      fb.postsCollection
        .doc(docId)
        .update({
          status
        })
        .then(() => {
          this.$toast.open({
            message: this.$t("posts.toast-post-deleted"),
            queue: false,
            type: "is-success"
          });
          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    },  
    
    scrollToTop() {
      var element = "#posts";
      var duration = 300;
      var options = {
        easing: "ease-in",
        offset: -80,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      this.$scrollTo(element, duration, options);
    },

  },

  /*
  snackbarSuccess() {
    this.$snackbar.open({
      duration: 4000,
      message: this.$t("posts.snackbar-post-updated"),
      type: "is-primary",
      position: "is-bottom",
      actionText: "Return to posts page",
      class: "has-background-info",
      queue: false,
      onAction: () => {
        this.$router.push("/posts");
      }
    });
  },*/
  snackbarError() {
    this.$snackbar.open({
      duration: 4000,
      message: this.$t("posts.snackbar-error"),
      type: "is-info",
      position: "is-bottom",
      actionText: this.$t("posts.snackbar-button-error"),
      queue: false,
      onAction: () => {
        this.$router.push("/dashboard");
      }
    });
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },

    formatCurrency (value) {
      if (isNaN(parseFloat(value))) {
          return value;
      }
      var formatter = new Intl.NumberFormat('en-IN', { 
        minimumFractionDigits: 0 })

      return formatter.format(value);
    },

    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  },

};
</script>